import styled from 'styled-components';
import { SideEnum } from '../../types/types';
import { Text } from '../Text';

/** TODO, this needs to be converged with the OrderFormSides.Twoway value we have floating around too... */
export const TWO_WAY_SIDE = '2-way' as const;

/**
 * The Side component can technically take any string type value, but here we anyway take the time to
 * force the implementer to provide the standard sides. The TWO_WAY_SIDE thing is a corner cut from the past. But the knot
 * around SideEnum, OrderSideEnum, TWO_WAY_SIDE is too much to unravel today.
 */
type SideType = SideEnum | typeof TWO_WAY_SIDE | null | undefined;

export const Side = styled(Text)<{ side: SideType }>`
  color: ${({ side, theme }) => {
    if (side === SideEnum.Buy) {
      return theme.colorTextPositive;
    }
    if (side === SideEnum.Sell) {
      return theme.colorTextNegative;
    }
    return theme.colorTextPrimary; // 2-way
  }};
  text-transform: uppercase;
`;

/**
 * Wraps the <Side> component and, if side is undefined, will render "2-way". If side is null, renders nothing.
 * On a Quote, if Side or TradedSide are undefined, this means this quote has no side (of course), meaning it is a 2-way Quote.
 */
export function QuoteSide({ side }: { side: SideType }) {
  return side === null ? null : <Side side={side}>{side === undefined ? TWO_WAY_SIDE : side}</Side>;
}
